var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavbarReviewOff = function SvgNavbarReviewOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4C4C4C",
    fillRule: "evenodd",
    d: "M20.25 22.5H6.75a3 3 0 0 1-3-3v-18h16.5zM5.25 3v15.75A2.25 2.25 0 0 0 7.5 21h11.25V3zM7.5 7.5h9V6h-9zm9 3.75h-9v-1.5h9zM12 15H7.5v-1.5H12z",
    clipRule: "evenodd"
  })));
};
export default SvgNavbarReviewOff;